import type { JSX } from "react";
// src/providers/AuthProvider.tsx

import { Loader } from "lucide-react";
import { useEffect } from "react";
import { AuthStatus } from "@/common/enums/enums";
import { useAuthStore } from "@/store/auth.store";

export const AuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const { signInWithCurrentUser, authStatus } = useAuthStore();

  useEffect(() => {
    void signInWithCurrentUser();
  }, [signInWithCurrentUser]);

  if (authStatus === AuthStatus.LOADING) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader aria-label="loading" className="animate-spin" role="img" />
      </div>
    );
  }

  return <>{children}</>;
};
